export const COUNTRY_CODES = {
  USA: 'USA',
  MEXICO: 'MEX',
  CANADA: 'CAN',
} as const;

export interface SupportedCountry {
  code: string;
  label: string;
}

export const SUPPORTED_COUNTRIES: SupportedCountry[] = [
  { code: COUNTRY_CODES.USA, label: 'USA' },
  { code: COUNTRY_CODES.MEXICO, label: 'MEX' },
  { code: COUNTRY_CODES.CANADA, label: 'CAN' },
];

export const DEFAULT_COUNTRY = COUNTRY_CODES.USA;

export const FORM_FIELDS = {
  MANUAL_GZC: 'manual_GZC',
  MANUAL_GZC_EDIT: 'manual_GZC_edit',
  COUNTRY: 'country',
} as const;

